import AdjustLeaveModal from "@/models/AdjustLeave";

const GET_ATTENDANCE_USER_MONTH_PAGING_LIST = 'GET_ATTENDANCE_USER_MONTH_PAGING_LIST';
const GET_ATTENDANCE_USER_DAY_PAGING_LIST = 'GET_ATTENDANCE_USER_DAY_PAGING_LIST';
// const GET_WORK_RESULT = 'GET_WORK_RESULT';
// const GET_RESULT_SEARCH = 'GET_RESULT_SEARCH';
const GET_ATTENDANCE_MONTH = 'GET_ATTENDANCE_MONTH';
const GET_ATTENDANCE_DAY_SP_INFO = 'GET_ATTENDANCE_DAY_SP_INFO';
const EXPORT_ATTENDANCE_MONTH = 'EXPORT_ATTENDANCE_MONTH';
const EXPORT_ATTENDANCE_DAY = 'EXPORT_ATTENDANCE_DAY';
const GET_ATTENDANCE_USER_DAY_ALL_INFO = 'GET_ATTENDANCE_USER_DAY_ALL_INFO';

// 每月考勤分页统计
async function getAttendanceUserMonthPagingList(params) {
  const payload = await new AdjustLeaveModal().attendanceUserMonthPagingList(params);
  return {
    type: GET_ATTENDANCE_USER_MONTH_PAGING_LIST,
    payload
  };
}

// 每日考勤分页统计
async function getAttendanceUserDayPagingList(params) {
  const payload = await new AdjustLeaveModal().attendanceUserDayPagingList(params);
  return {
    type: GET_ATTENDANCE_USER_DAY_PAGING_LIST,
    payload
  };
}

// // 获取考勤状态字典匹配
// async function getWorkResult() {
//   const payload = await new AdjustLeaveModal().sysDicListByDicName('ATTENDANCE_WORK_RESULT');
//   return {
//     type: GET_WORK_RESULT,
//     payload
//   };
// }

// // 获取打卡状态下拉框选项
// async function getResultSearch() {
//   const payload = await new AdjustLeaveModal().sysDicListByDicName('ATTENDANCE_RESULT_SEARCH');
//   return {
//     type: GET_RESULT_SEARCH,
//     payload
//   };
// }

// 用户月度考勤弹窗总结
async function getAttendanceMonth(params) {
  const payload = await new AdjustLeaveModal().getAttendanceMonth(params);
  return {
    type: GET_ATTENDANCE_MONTH,
    payload
  };
}

// 用户每日审批单详情列表
async function getattendanceDaySpInfo(params) {
  const payload = await new AdjustLeaveModal().getattendanceDaySpInfo(params);
  return {
    type: GET_ATTENDANCE_DAY_SP_INFO,
    payload
  };
}

// 用户每月考勤导出
async function exportAttendanceMonth(params) {
  const payload = await new AdjustLeaveModal().exportAttendanceMonth(params);
  return {
    type: EXPORT_ATTENDANCE_MONTH,
    payload
  };
}

// 用户每日考勤导出
async function exportAttendanceDay(params) {
  const payload = await new AdjustLeaveModal().exportAttendanceDay(params);
  return {
    type: EXPORT_ATTENDANCE_DAY,
    payload
  };
}

// 每日内容：考勤和审批单
async function getattendanceUserDayAllInfo(params) {
  const payload = await new AdjustLeaveModal().getattendanceUserDayAllInfo(params);
  return {
    type: GET_ATTENDANCE_USER_DAY_ALL_INFO,
    payload
  };
}

const ACTION = {
  getAttendanceUserMonthPagingList,
  getAttendanceUserDayPagingList,
  // getWorkResult,
  // getResultSearch,
  getAttendanceMonth,
  getattendanceDaySpInfo,
  exportAttendanceMonth,
  exportAttendanceDay,
  getattendanceUserDayAllInfo,
};
const ACTION_TYPES = {
  GET_ATTENDANCE_USER_MONTH_PAGING_LIST,
  GET_ATTENDANCE_USER_DAY_PAGING_LIST,
  // GET_WORK_RESULT,
  // GET_RESULT_SEARCH,
  GET_ATTENDANCE_MONTH,
  GET_ATTENDANCE_DAY_SP_INFO,
  EXPORT_ATTENDANCE_MONTH,
  EXPORT_ATTENDANCE_DAY,
  GET_ATTENDANCE_USER_DAY_ALL_INFO,
};

const Attendance = {
  ACTION_TYPES,
  ACTION
};
export default Attendance;